import { render } from "./wSelectRemote.vue?vue&type=template&id=5f6989bf&ts=true"
import script from "./wSelectRemote.vue?vue&type=script&lang=ts"
export * from "./wSelectRemote.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__